/*
 * @Date: 2025-04-01 17:52:01
 * @Description:任务管理
 */
import taskMgmtList from '../views/task-mgmt-list.vue';
import taskQuickAuditList from '../views/task-quick-audit-list.vue';

export const route = [
  {
    path: '/main/asp/task-mgmt-list/list',
    name: 'asp-task-mgmt-list',
    meta: {
      title: '任务管理'
    },
    component: taskMgmtList
  },
  {
    path: '/main/asp/task-mgmt-list/quick-list',
    name: 'asp-task-mgmt-quick-list',
    meta: {
      title: '快捷审核',
      parentPath: '/main/asp/task-mgmt-list/list'
    },
    component: taskQuickAuditList
  },
  {
    path: '/main/supplier/task-mgmt-list/list',
    name: 'supplier-task-mgmt-list',
    meta: {
      title: '任务管理'
    },
    component: taskMgmtList
  },
  {
    path: '/main/supplier/task-mgmt-list/quick-list',
    name: 'supplier-task-mgmt-quick-list',
    meta: {
      title: '快捷审核',
      parentPath: '/main/supplier/task-mgmt-list/list'
    },
    component: taskQuickAuditList
  },
  {
    path: '/main/industry/task-mgmt-list/list',
    name: 'industry-task-mgmt-list',
    meta: {
      title: '任务管理'
    },
    component: taskMgmtList
  },
  {
    path: '/main/industry/task-mgmt-list/quick-list',
    name: 'industry-task-mgmt-quick-list',
    meta: {
      title: '快捷审核',
      parentPath: '/main/industry/task-mgmt-list/list'
    },
    component: taskQuickAuditList
  }
];
